import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BackendConfiguration} from '@application/configuration/backend-configuration';
import {ScheduleCustomSettings} from '@domain/calendar/schedule/custom-settings/schedule-custom-settings';
import {map, Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class HttpSchedulesCustomSettingsService {
  private baseUrl: string;

  public constructor(
    private readonly httpClient: HttpClient,
    private readonly backendConfiguration: BackendConfiguration
  ) {
    this.baseUrl = `${backendConfiguration.getCalendarEndpoint()}custom-settings`;
  }

  public get(): Observable<ScheduleCustomSettings> {
    return this.httpClient.get(this.baseUrl).pipe(map((json: any) => ScheduleCustomSettings.fromJSON(json)));
  }

  public save(customSettings: ScheduleCustomSettings): Observable<void> {
    return this.httpClient.post<void>(this.baseUrl, customSettings.toJSON());
  }
}
